import Vue from 'vue'
import GlobalEventBus from './EventBus'

let ifSession = localStorage.getItem('user')
//let nameUser = localStorage.getItem('nombreUsuarioLogueadoTramite') !== null ? localStorage.getItem('nombreUsuarioLogueadoTramite') : localStorage.getItem('nombreUsuarioLogueadoTramite')
let nameUser=''
try{
   nameUser = localStorage.getItem('nombreUsuarioLogueadoTramite').trim() != '' ? localStorage.getItem('nombreUsuarioLogueadoTramite') : localStorage.getItem('nombreCompletoLogueadoTramite')
}catch(e){
  nameUser=''
}

//let nameUser = localStorage.getItem('nombreUsuarioLogueadoTramite')==null||localStorage.getItem('nombreUsuarioLogueadoTramite').trim()==''?
  //        localStorage.getItem('nombreCompletoLogueadoTramite'):localStorage.getItem('nombreUsuarioLogueadoTramite')
//nameUser= nameUser!=null&&nameUser.trim()==''?localStorage.getItem('nombreCompletoLogueadoTramite'):nameUser
if (ifSession && nameUser) {
  Vue.prototype.$cache = null
  Vue.prototype.$userLogged = true
  Vue.prototype.$nameUser = nameUser
} else {
  Vue.prototype.$cache = null
  Vue.prototype.$userLogged = false
  Vue.prototype.$nameUser = null
}


GlobalEventBus.$on('login', (nameUser) => {
  localStorage.setItem('user',true)
  Vue.prototype.$nameUser = nameUser
  Vue.prototype.$userLogged = true
  
})
GlobalEventBus.$on('logout', () => {
  window.rutaReturn = '/' 
  Vue.prototype.$userLogged = false
  Vue.prototype.$nameUser = null
  localStorage.clear()
})



// WEBPACK FOOTER //
// ./src/helpers/Auth.js